var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.can_view_side_bar)?_c('dashboard-app'):_c('guest-app')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }